import { render, staticRenderFns } from "./add-contacts.vue?vue&type=template&id=b05d6492&"
import script from "./add-contacts.vue?vue&type=script&lang=js&"
export * from "./add-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports